import { useWindowSize } from "src/hooks";

import DefaultLogBar from "./DefaultLogBar/DefaultLogBar";
import MediumWidthLogbar from "./MediumWidthLogBar/MediumWidthLogBar";
import { PendingFilesProvider } from "./PendingFilesContext";
import SmallWidthLogBar from "./SmallWidthLogBar/SmallWidthLogBar";

const LogBar = () => {
  const { width } = useWindowSize();

  return (
    <PendingFilesProvider>
      {width <= 1080 && <SmallWidthLogBar />}
      {width <= 1720 && width > 1080 && <MediumWidthLogbar />}
      {width > 1720 && <DefaultLogBar />}
    </PendingFilesProvider>
  );
};

export default LogBar;
